export const GET_DELIVERY_MEN = "GET_DELIVERY_MEN"
export const GET_DELIVERY_MEN_SUCCESS = "GET_DELIVERY_MEN_SUCCESS"
export const GET_DELIVERY_MEN_FAIL = "GET_DELIVERY_MEN_FAIL"

export const GET_DELIVERY_MAN = "GET_DELIVERY_MAN"
export const GET_DELIVERY_MAN_SUCCESS = "GET_DELIVERY_MAN_SUCCESS"
export const GET_DELIVERY_MAN_FAIL = "GET_DELIVERY_MAN_FAIL"

export const CREATE_DELIVERY_MAN = "CREATE_DELIVERY_MAN"
export const CREATE_DELIVERY_MAN_SUCCESS = "CREATE_DELIVERY_MAN_SUCCESS"
export const CREATE_DELIVERY_MAN_FAIL = "CREATE_DELIVERY_MAN_FAIL"

export const UPDATE_DELIVERY_MAN = "UPDATE_DELIVERY_MAN"
export const UPDATE_DELIVERY_MAN_SUCCESS = "UPDATE_DELIVERY_MAN_SUCCESS"
export const UPDATE_DELIVERY_MAN_FAIL = "UPDATE_DELIVERY_MAN_FAIL"

export const DELETE_DELIVERY_MAN = "DELETE_DELIVERY_MAN"
export const DELETE_DELIVERY_MAN_SUCCESS = "DELETE_DELIVERY_MAN_SUCCESS"
export const DELETE_DELIVERY_MAN_FAIL = "DELETE_DELIVERY_MAN_FAIL"
